import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import cardsBg from "assets/images/common/others/cardsBg.png";
import { useLocation, useNavigate } from "react-router-dom";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";
import useUsers from "containers/user-management/useHooks";
import useUtils from "hooks/useUtils";

const ViewExperienceParticipants = () => {
  const [data, setData] = useState<any>({});
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const navigate = useNavigate();
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  const { markAttendanceAmbassadorExperience, getAmbassadorExperienceById } =
    useUsers();

  const [activeTab, setActiveTab] = useState("attendance");
  const [attendanceData, setAttendanceData] = useState<any[]>([]);
  const [isMarkingAttendance, setIsMarkingAttendance] = useState(false);

  useEffect(() => {
    if (params?.id) {
      getAmbassadorExperienceById(params.id, (fetchedData: any) => {
        setData(fetchedData);
        if (fetchedData.subscriptions) {
          setAttendanceData(fetchedData.subscriptions);
        }
      });
    }
  }, [params?.id]);

  const goToBack = () => {
    navigate(-1);
  };

  const markAttendance = async (userId: number, isAttended: boolean) => {
    if (isMarkingAttendance || !data?.id) return;

    setIsMarkingAttendance(true);

    const requestBody = [
      {
        user_id: userId,
        attend: isAttended,
      },
    ];

    await markAttendanceAmbassadorExperience(data?.id, requestBody);
    
    getAmbassadorExperienceById(data?.id, (updatedData: any) => {
      setData(updatedData);
      if (updatedData.subscriptions) {
        setAttendanceData(updatedData.subscriptions);
      }
    });

    setIsMarkingAttendance(false);
  };

  const allSubscribers = attendanceData;

  const participants = attendanceData.filter(
    (item: any) => item?.attend === true
  );

  return (
    <div>
      <h1 className="text-base text-primaryText font-bold flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        {data?.name || "Participants"}
      </h1>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[20px] p-6 my-6">
        <div className="flex gap-4 items-center flex-wrap">
          <h1 className="text-[20px] md:text-[26px] lg:text-[32px] font-bold text-primaryText">
            {data?.name || ""}
          </h1>
          <p className="bg-peachFadeBg text-darkYellowText text-sm font-medium rounded-md px-2 py-1">
            Ambassador Experience
          </p>
        </div>

        <div className="flex flex-wrap gap-4 mt-6">
          <button
            className={`py-3 px-6 text-base font-semibold rounded-lg transition-colors duration-300 ${
              activeTab === "attendance"
                ? "bg-lightBlueColor text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
            onClick={() => setActiveTab("attendance")}
          >
            Attendance
          </button>
          <button
            className={`py-3 px-6 text-base font-semibold rounded-lg transition-colors duration-300 ${
              activeTab === "participants"
                ? "bg-lightBlueColor text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
            onClick={() => setActiveTab("participants")}
          >
            Participants 
          </button>
        </div>

        <div className="mt-6">
          {activeTab === "attendance" && (
            <div>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-primaryText">
                  Mark Attendance
                </h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 py-5">
                {allSubscribers.length > 0 ? (
                  allSubscribers.map((subscriber: any, index: number) => {
                    const isAttended = subscriber?.attend || false;

                    return (
                      <div
                        key={index}
                        className={`relative flex flex-col items-center justify-center p-6 rounded-lg cursor-pointer transition-all duration-300 border-2 ${
                          isAttended
                            ? "border-yellowBorder"
                            : "border-gray-200 hover:border-gray-300"
                        }`}
                        style={{ backgroundImage: `url(${cardsBg})` }}
                      >
                        <div className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center">
                          <input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={isAttended}
                            disabled={isMarkingAttendance}
                            onChange={() =>
                              markAttendance(subscriber.user?.id, !isAttended)
                            }
                          />
                        </div>

                        <img
                          className="w-[98px] h-[98px] rounded-full object-cover"
                          src={
                            subscriber?.user?.profilePicId
                              ? concatPathWithBackendUrl(
                                  subscriber?.user?.profilePicId
                                )
                              : editProfilePicUser
                          }
                          alt={subscriber?.user?.firstName || "Subscriber"}
                        />

                        <span className="text-lg font-semibold mt-3 text-primaryText text-center">
                          {subscriber?.user?.firstName}{" "}
                          {subscriber?.user?.lastName}
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <div className="col-span-full text-center py-8">
                    <DataNotFound show={true} />
                  </div>
                )}
              </div>
            </div>
          )}
          {activeTab === "participants" && (
            <div>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-primaryText">
                  Present Participants
                </h2>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 py-5">
                {participants.length > 0 ? (
                  participants.map((participant: any, index: number) => (
                    <div
                      key={index}
                      className="relative flex flex-col items-center justify-center p-6 rounded-lg border-2 border-yellowBorder"
                      style={{ backgroundImage: `url(${cardsBg})` }}
                    >
                      <div className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center">
                        <input
                          type="checkbox"
                          className="custom-checkbox"
                          checked={true}
                          disabled={true}
                        />
                      </div>

                      <img
                        className="w-[98px] h-[98px] rounded-full object-cover"
                        src={
                          participant?.user?.profilePicId
                            ? concatPathWithBackendUrl(
                                participant.user.profilePicId
                              )
                            : editProfilePicUser
                        }
                        alt={participant?.user?.firstName || "Participant"}
                      />

                      <span className="text-lg font-semibold mt-3 text-primaryText text-center">
                        {participant?.user?.firstName}{" "}
                        {participant?.user?.lastName}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="col-span-full text-center py-8">
                    <DataNotFound show={true} />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewExperienceParticipants;
